const config = {
  // basename: only at build time to set, and don't add '/' at end off BASENAME for breadcrumbs,  like '/berry-material-react/react/default'
  basename: "/",
  defaultPath: "/dashboard/pending-claims",
  fontFamily: `'Roboto', sans-serif`,
  borderRadius: 12,
  theme: "light" as "light" | "dark",
  i18n: "en"
};
export default config;